import React from 'react'

import { SUBSCRIPTION_STATE } from '../../../util/subscriptions'
import SubmitButton from '../../common/SubmitButton'

const SubscriptionButton = ({ handleClick, state, submitting, ...rest }) => {
  let text = ''
  switch (state) {
    case SUBSCRIPTION_STATE.EVERGREEN_UNSUBSCRIBED:
      text = 'Subscribe'
      break
    case SUBSCRIPTION_STATE.TRIAL_UNSUBSCRIBED:
      text = 'Try For Free'
      break
    case SUBSCRIPTION_STATE.TRIAL_UNSUBSCRIBED_ACTIVE:
    case SUBSCRIPTION_STATE.EVERGREEN_UNSUBSCRIBED_ACTIVE:
      text = 'Resubscribe'
      break
    default:
      text = ''
      break
  }

  return (
    <SubmitButton
      color="primary"
      onClick={handleClick}
      submitting={submitting}
      variant="contained"
      {...rest}
    >
      {text}
    </SubmitButton>
  )
}

export default SubscriptionButton
